import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";
export const socialList = [
  {
    icon: <FaTelegramPlane />,
    text: "Telegram",
    link: "https://www.t.me/mozzledoge",
  },
  // {
  //   icon: <FaDiscord />,
  //   text: "Discord",
  //   link: "",
  // },
  {
    icon: <FaTwitter />,
    text: "Twitter",
    link: "https://www.twitter.com/mozzledoge",
  },
];
